window.merge_objects = (obj1,obj2)->
  obj3 = {}
  for attrname of obj1
    obj3[attrname] = obj1[attrname]
  for attrname of obj2
    obj3[attrname] = obj2[attrname]
  obj3

window.params_from_url = (url)->
  params = {}
  splitted_url = url.split('#')
  splitted_url = splitted_url[0].split('?')
  return params if splitted_url.length == 1 or splitted_url[1] == ''
  string_params = splitted_url[1]
  if string_params.match(/&/)
    string_params = string_params.substring(1, string_params.length) if string_params.match(/^&/)
    string_params = string_params.replace(/&/g,"=")
  split_params_get = string_params.split("=")
  $.each split_params_get, (i,param)->
    if not ((i/2)+"").match(/\./) or (i/2)==0
      if param.match(/%5B%5D/)
        _param = param.replace('%5B%5D','')
        params[_param] ||= []
        params[_param].push split_params_get[i+1]
      else if param.match(/\[\]/)
        _param = param.replace('[]','')
        params[_param] ||= []
        params[_param].push split_params_get[i+1]
      else
        params[param] = split_params_get[i+1]
    else return
  params

window.add_params_to_url = (url, params)->
  final_url = null
  splitted_url = url.split('?')
  params_url = params_from_url(url)
  if typeof params == 'object'
    params_url = merge_objects(params_url, params)
  else if typeof params == 'string'
    _params = params_from_url("?"+params)
    params_url = merge_objects(params_url, _params)
  all_params = []
  $.each params_url, (k,v)->
    if typeof v == 'object'
      $.each v, (k2,v2)->
        all_params.push k+"[]="+v2
    else
      all_params.push k+"="+v
  if all_params.length > 0
    new_url = splitted_url[0]+"?"+all_params.join('&')
  else
    new_url = splitted_url[0]
  new_url

window.remove_params_from_url = (url, params)->
  base_url = url.split('?')[0]
  url_params = params_from_url(url)
  $.each params, (i,param)->
    delete url_params[param]
  add_params_to_url(base_url, url_params)

stickyFooter = ->
  fh = $('#footer').outerHeight()
  $('#all-content-page').css
    paddingBottom: fh

$ ->
  stickyFooter()

  # Link per copiare un url
  $(".copy-button").addClass('clipboard')
  clipboard = new ClipboardJS '.copy-button', {
    text: (trigger)->
      trigger.getAttribute('data-url')
  }
  clipboard.on 'success', (e)->
    alert e.trigger.getAttribute('data-text')

  # Filtro categorie
  $('#content-select-category select').on 'change', ->
    val = $(@).val()
    $('.course-block').show()
    if val != ''
      if $('#ajax_container .navigation').length > 0
        document.location = "/courses/?sfwd_cat_id=#{val}"
      else
        $('.course-block').each ->
          $(@).hide() if $(@).find(".category[data-id='#{val}']").length == 0
    else if $('#ajax_container .navigation').length > 0
      document.location = "/courses/"
    n_show_courses = $('.course-block:visible').size()
    n_columns = if n_show_courses < 3 then n_show_courses else 3
    $('.course-block').first().parent().attr('class', "columns#{n_columns}")

  # Rimuovi sidebar se vuota
  if $('#post-content .entry.with-sidebar').length > 0 and $('#sidebar > div').html() == ''
    $('#post-content .entry.with-sidebar').removeClass('with-sidebar')
    $('#sidebar').remove()

  # Gestione commenti
  $(".wrap-comments-content textarea").on "click", (event)->
    event.preventDefault()
    wrapComments = $('.wrap-comments-content')
    $(@).val '' if $(@).val() == $(@).attr('data-default')
    unless wrapComments.hasClass('open')
      wrapComments.addClass('open')
      showComments = $("#show-comments")

  $(".wrap-comments-content textarea").on "focus", (event)->
    event.preventDefault()
    wrapComments = $('.wrap-comments-content')
    $(@).val '' if $(@).val() == $(@).attr('data-default')
    unless wrapComments.hasClass('open')
      wrapComments.addClass('open')
      showComments = $("#show-comments")

  $('#add-comment-link').on 'click', (event)->
    event.preventDefault()
    $('textarea#comment').focus() unless $('.wrap-comments-content').hasClass('open')

  $("#show-comments").on "click", (event)->
    event.preventDefault()
    wrapComments = $('.wrap-comments-content')
    textareaComment = $(".wrap-comments-content textarea")
    showComments = $(@)
    next = showComments.attr('data-opposite-text')
    actual = showComments.html()
    titleBtn = showComments.attr("title")
    if actual != titleBtn
      wrapComments.addClass('open')
    else
      wrapComments.removeClass('open')
      if textareaComment.val() == ""
        textareaComment.val textareaComment.attr('data-default')
    showComments.attr 'data-opposite-text', actual
    showComments.html next
  # Fine gestione commenti

# Nuova form commenti che passa da DEMO
$ ->
  if $('#demo_commentform[data-comment-sent="yes"]').length > 0
    alert('Commento inviato con successo!')
    url = remove_params_from_url(window.location.href, ['comment-sent'])
    document.location = url

  arr_phone1 = ["", ".", '390000000000', "000000000", "0000000000", "0000000000000", "1111", "11111", "111111111", "123123123", "123", "1234", "12345", "123456", "1234567", "123456778", "12345678", "123456789", "1234567890", "1234567899", "123456798", "222222222", "1234567891", "1324343123", "1787012", "213123123", "2323232323", "234234", "23456789", "39", "+39", "3213213213"]
  arr_phone2 = []
  $.each arr_phone1, (i,fmp)->
    arr_phone2.push "39"+fmp if $.inArray(fmp, ["",".","+39"]) == -1
  fake_mobile_phones = $.unique($.merge(arr_phone1,arr_phone2))

  $('#demo_commentform .field.required input').on 'change', ->
    phone_rg = /\+*([0-9\/\-\.\s]+){5,}/
    email_rg = /^([\w\.\-\+]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/
    _val = $(@).val()
    if ($(@).attr('id') == 'email' and not email_rg.test(_val)) or ($(@).attr('id') == 'mobile_phone' and (not phone_rg.test(_val) or $.inArray(_val, fake_mobile_phones) >= 0)) or _val == ''
      $(@).parents('.field').addClass('error')
    else
      $(@).parents('.field').removeClass('error')

  $('#demo_commentform .field.required textarea').on 'change', ->
    _val = $(@).val()
    if _val == '' or _val == $(@).attr('data-default')
      $(@).parents('.field').addClass('error')
    else
      $(@).parents('.field').removeClass('error')
      # if /.*https?:\/\//.test(_val)
      #   $(@).parents('.field').addClass('error')
      #   alert 'Non puoi inserire dei link nel commento!'
      # else
      #   $(@).parents('.field').removeClass('error')

  $('#demo_commentform').on 'submit', (event)->
    $(@).find('.field.required').each ->
      field = $(@).find('input')
      field = $(@).find('textarea') if field.length == 0
      field.trigger('change') if field.length > 0
    if $(@).find('.field.error').length > 0 or $(@).find('#email_confirmation').val() != ''
      event.preventDefault()
      alert 'Compila tutti i campi obbligatori!'
      # if $(@).find('.field.error #comment_content').length > 0 and $(@).find('.field.error #comment_content').val() != ''
      #   if $(@).find('.field.error').length == 1
      #     alert 'Non puoi inserire dei link nel commento!'
      #   else
      #     alert 'Non puoi inserire dei link nel commento!\nCompila tutti i campi obbligatori!'
      # else
      #   alert 'Compila tutti i campi obbligatori!'
# Fine nuova form commenti che passa da DEMO

$(window).on 'resize', ->
  stickyFooter()